var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicyOwner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.685 12c-.346-.147-.455-.412-.448-.78.016-.94.005-1.88.005-2.822v-.217c1.772 1.157 3.53 1.16 5.317 0v.198c0 .947-.012 1.895.005 2.841.007.367-.103.632-.449.78H5.82c-.59-.336-1.183-.67-1.77-1.01-.11-.065-.19-.063-.3 0-.587.342-1.18.674-1.77 1.01h-.295z",
    fill: "#26A96C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91 0A3.906 3.906 0 0 1 7.8 3.915a3.91 3.91 0 0 1-3.899 3.886A3.908 3.908 0 0 1 0 3.895 3.905 3.905 0 0 1 3.91 0zm-.562 4.019c-.183-.118-.344-.235-.516-.333a.698.698 0 0 0-.938.22.686.686 0 0 0 .154.948c.376.271.764.53 1.16.77.303.185.69.111.89-.181a68.334 68.334 0 0 0 1.48-2.228c.234-.37.038-.841-.37-1-.304-.116-.628-.017-.832.28-.344.496-.676 1-1.028 1.524z",
    fill: "#26A96C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h7.801v12H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyOwner);
export default ForwardRef;